import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Partido } from 'src/app/models/partido';
import { Quiniela } from 'src/app/models/quiniela';
import { Jugador } from 'src/app/models/jugador';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { JugadorService } from 'src/app/services/jugadores.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-jugador-page',
  templateUrl: './jugador-page.component.html',
  styleUrls: ['./jugador-page.component.css']
})
export class JugadorPageComponent implements OnInit {
  quiniela: Quiniela;
  urlQuiniela: string;
  partidos: Array<Partido> = [];
  isLoading = true;
  verParticipacion = false;
  pote: number;

  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private PartidosService: PartidosService,
    private JugadorService: JugadorService,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL de la Quiniela
    this.urlQuiniela = this.rutaActiva.snapshot.params.url;
    this.urlQuiniela = this.urlQuiniela.toLowerCase();
    console.log(this.urlQuiniela)

    // Obtener todas las quinielas y buscar la que corresponde con el URL
    this.getQuinielaByURL()

  }

  getQuinielaByURL(): void {
    this.isLoading = true;
    var quinielas: Array<Quiniela> = [];


    this.QuinielasService.getQuinielaByURL(this.urlQuiniela).subscribe((items) => {
      // Setting up quinielas
      quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );

      // Es la unica que trae del arreglo
      this.quiniela = quinielas[0]

      if (this.quiniela != undefined) {

        // Calcular el Pote
        //this.calcularPote()

        // Terminar cargando
        this.isLoading = false;

      } else {
        // Enviar el Alerta
        Swal.fire({
          icon: 'error',
          title: 'La quiniela no existe',
          text: 'Por favor, revise que este escribiendo correctamente el URL de la quiniela a la que desea participar.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#28a745',
        })
      }

    });

  }

  /*
  calcularPote() {
    var jugadores: Array<Jugador> = [];
    this.JugadorService.getAllJugadoresByIdQuiniela(this.quiniela.$key).subscribe((items) => {
      // Setting up jugador
      jugadores = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Jugador)
      );

      // Filtar que sean solo jugadores confirmados
      let jugadoresConfirmados = [];
      for (const jugador of jugadores) {
        if (jugador.confirmado) {
          jugadoresConfirmados.push(jugador);
        }
      }

      // Calcular cuanto es el pote
      var totalJugadores = jugadoresConfirmados.length;
      var precioQuiniela = this.quiniela.precio;
      var porcentajePote = this.quiniela.porcentaje;

      this.pote = ((totalJugadores * precioQuiniela) * porcentajePote) / 100;

      console.log(totalJugadores, precioQuiniela, porcentajePote, this.pote)

      this.quiniela.pote = this.pote;

      this.QuinielasService.updateQuiniela(this.quiniela, this.quiniela.$key).then((res) => {
        console.log("Se ha editado con exito el pote de la Quiniela");
      });

    });
  }
*/

  participar() {
    (<HTMLInputElement>document.getElementById("heroCarousel")).classList.add('animate__animated', 'animate__faster', 'animate__bounceOutLeft');
    var id = this.quiniela.$key
    setTimeout(() => { this.router.navigate(['participar', id]); }, 500);
  }

  Flecha: AnimationOptions = {
    path: '/assets/img/flecha.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

}
